module.exports = __webpack_public_path__ + "img/integratedLogo4.aa2eed68.png";